import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { FiSearch, FiX } from 'react-icons/fi'
import './CategoryToolbar.css'

const CategoryToolbar = ({ parent, search, onSearchChange, category, onCategoryChange, showCategoryFilter = true }) => {
    const [categories, setCategories] = useState([])

    useEffect(() => {
        if (!showCategoryFilter) return
        axios.get(`${process.env.REACT_APP_API_URL}/sous-categorie/lister`, { headers: { parent } })
            .then((res) => setCategories(res.data))
            .catch(() => {})
    }, [parent, showCategoryFilter])

    return (
        <div className={`hd-catbar ${!showCategoryFilter ? 'hd-catbar--compact' : ''}`}>
            <div className="hd-catbar-search">
                <FiSearch className="hd-catbar-search-icon" />
                <input
                    type="text"
                    placeholder="Rechercher un article…"
                    value={search}
                    onChange={(e) => onSearchChange(e.target.value)}
                />
                {search && (
                    <button type="button" className="hd-catbar-search-clear" onClick={() => onSearchChange('')} aria-label="Effacer">
                        <FiX />
                    </button>
                )}
            </div>

            {showCategoryFilter && (
                <select className="hd-catbar-select" value={category} onChange={(e) => onCategoryChange(e.target.value)}>
                    <option value="all">Toutes les catégories</option>
                    {categories.map((c) => (
                        <option key={c._id} value={c.name}>{c.name}</option>
                    ))}
                </select>
            )}
        </div>
    )
}

export default CategoryToolbar
